import { Bet, BetState,TotalOdd,WidgetConfig } from '../types';

export const STORAGE_KEY = 'b2tech-bet-builder-state';
export const STORAGE_VERSION = 10; 

export interface VersionedState extends BetState {
  __version: number;
  
}

export const getInitialState = (initialBets: Bet[] = [], config:WidgetConfig): VersionedState => {
  try {
    const savedState = localStorage.getItem(STORAGE_KEY);
    if (savedState) {
      const parsedState: VersionedState = JSON.parse(savedState);
      parsedState.config = config;
      if (parsedState.__version === STORAGE_VERSION) {
        if(initialBets.length>0){
          parsedState.bets = initialBets;  
                  
        }
        return parsedState;
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  } catch (error) {
    console.error('Error reading from localStorage:', error);
  }
  
  const newState: VersionedState = {
    bets: initialBets,
    totalOdds: [],
    __version: STORAGE_VERSION,
    config: config
  };
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
  return newState;
};
export const createInitialState = (
  
): VersionedState => {
  let state: VersionedState = {
    __version:STORAGE_VERSION,
    bets: [],
    totalOdds: [],
    
    config: {}
  };
  return state;
};